// extracted by mini-css-extract-plugin
export default {"root":"AgencyProperties__root--URCD7","holder":"AgencyProperties__holder--yDIE8"};